import {
  CALENDAR_REQUEST, CALENDAR_SUCCESS, CALENDAR_FAILURE
} from '../actions/calendars'

const INITIAL_STATE = {
  calendar: null, calendars: null, error: null, loading: false
}

const calendarsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CALENDAR_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case CALENDAR_SUCCESS:
      return {
        ...state,
        calendar: action.response, error: null, loading: false
      }
    case CALENDAR_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    default:
      return state
  }
}

export default calendarsReducer


